import { render } from "./images.vue?vue&type=template&id=4fc7866b"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__